import FJConstant from '../../../../constants/FJConstant';
import FJAutoVideoRemoveBgProgressContainer from '../container/FJAutoVideoRemoveBgProgressContainer';
import FJVideoRemovePreviewBox from './FJVideoRemovePreviewBox';
import PropTypes from 'prop-types';

const FJVideoRemoveBgAutoRight = ({
    setCanvas,
    playVideo,
    pauseVideo,
    isPlay,
    autoEditVideoInfo,
    autoRemoverStatus,
    autoEditVideoIsUploading,
}) => {
    return (
        <>
            {(autoRemoverStatus === FJConstant.DEFAULT || autoRemoverStatus === FJConstant.SUCCESS) && (
                <FJVideoRemovePreviewBox
                    setCanvas={setCanvas}
                    isAutoRemoveBg={true}
                    playVideo={playVideo}
                    pauseVideo={pauseVideo}
                    isPlay={isPlay}
                    disabled={autoRemoverStatus !== FJConstant.SUCCESS || autoEditVideoIsUploading}
                    editVideoInfo={autoEditVideoInfo}
                />
            )}

            {autoRemoverStatus !== FJConstant.DEFAULT && autoRemoverStatus !== FJConstant.SUCCESS && (
                <FJAutoVideoRemoveBgProgressContainer />
            )}
        </>
    );
};

FJVideoRemoveBgAutoRight.propTypes = {
    setCanvas: PropTypes.func.isRequired,
    autoEditVideoInfo: PropTypes.object,
    autoRemoverStatus: PropTypes.string,
    autoEditVideoIsUploading: PropTypes.bool,
    playVideo: PropTypes.func,
    pauseVideo: PropTypes.func,
    isPlay: PropTypes.bool,
};

export default FJVideoRemoveBgAutoRight;
